<template>
    <div class="MIndex">
        <div class="nav">
            <div class="nav-top-phone fl">
                400-777-1147
            </div>
            <div class="nav-top-email fr">
                chengxie@orancrab.com
            </div>
        </div>
        <mt-header class="header" title="橙蟹企服">
            <mt-button style="margin-top:12px" @click="stateChange(1)" v-if="state" slot="left"><i class="el-icon-menu fl"></i></mt-button>
            <mt-button style="margin-top:12px" @click="stateChange(2)" v-else slot="left"><i class="el-icon-arrow-left fl"></i></mt-button>
            <a class="" slot="right" href="https://h5.youzan.com/v2/showcase/feature?alias=1gamaxj72">商城</a>
        </mt-header>

        <router-view />

        <footer class="footer">
            <div class="footerBox" v-for="(item, index) in footerList" @click="Jump(item.url)" :key="index">
                {{item.name}}
            </div>
            <a class="gxb" href="http://www.miitbeian.gov.cn">版权所属©深圳云桥信息技术有限公司 2018 粤ICP备15002630号-2</a>
        </footer>
    </div>
</template>

<script>
    export default {
        name: 'MIndex',
        data() {
            return {
                state: true,
                footerList: [
                {
                    name: '加入我们',
                    url: '/MaboutUs/4'
                },
                {
                    name: '联系我们',
                    url: '/MaboutUs/5'
                },
                {
                    name: '法律声明',
                    url: '/MlegalNotice'
                },
                {
                    name: '隐私保护',
                    url: '/Mprivacy'
                },
                {
                    name: '活动印花',
                    url: '/Mactivity'
                }]
            }
        },
        watch: {
            '$route'(to, from) {
                if (to.path == '/navList') {
                    this.state = false;
                } else {
                    this.state = true;
                }
            }
        },
        methods: {
            Jump(url) {
                this.$router.push({ path: url });
            },
            stateChange(id) {
                if (id === 1) {
                    this.$router.push({ path: '/navList' });
                } else {
                    this.$router.back(-1);
                }
            }
        }
    }
</script>

<style scoped>
    .header {
        width: 100%;
        height: 50px;
        line-height: 50px;
        background-color: #2e324f;
    }

    footer {
        width: 96%;
        background-color: #2e324f;
        padding: 2% 2%;
    }

    .gxb {
        display: inline-block;
        padding-left: 2%;
        color: #585b72;
        font-size: 12px
    }

    .footerBox {
        display: inline-block;
        padding: 0 2%;
    }

    .nav {
        /* background-color: #2e324f;  */
        text-align: center
    }

    .nav div {
        display: inline-block;
    }

    .nav .nav-top-phone {
        background: url('../assets/img/home－image－iphon.png') no-repeat;
        padding-left: 28px;
        margin: 0 4%;
    }

    .nav .nav-top-email {
        background: url('../assets/img/home－image－email.png') no-repeat;
        padding-left: 28px;
        margin: 0 4%;
    }
</style>



// WEBPACK FOOTER //
// src/components/m_index.vue